import { AddressSummary } from "./address-summary";

export function generateAddressSummary(address: Partial<AddressSummary>): AddressSummary {
  return {
    name: "",
    accountId: "",
    organizationId: "",
    aor: "",
    addressType: "none",
    username: "",
    domain: "",
    addressId: "",
    type: "none",
    ...address
  };
}
